import { Component } from "react"

import genericFilterGroup from "shared/search/containers/FilterGroup/FilterGroups.js"

import {
    createListFilter,
    createNotInListFilter,
    ManuallyChangedInListFilter,
    RegionCountryEUFilter,
} from "shared/search/containers/Filter/Filters"

import { inIssueFilter, notInIssueFilter } from "shared/search/containers/Filter/FilterCreators"

import {
    CommitteeTypeFilter,
    CommitteeIsParentFilter,
    CommitteeOfficialFilter,
    CommitteeSubcommitteeFilter,
    CommitteeSupportedRegionsFilter,
} from "shared/search/containers/Filter/CommitteeFilters"

export class CommitteeTypeFilterGroup extends Component {
    static defaultProps = {
        filters: [CommitteeTypeFilter, CommitteeIsParentFilter],
        uniqueFilterGroupId: "committeeTypeFilterGroup",
        displayLabel: "Committee Type",
        helpText: "Filter committees by committee type.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class CommitteeMemberFilterGroup extends Component {
    static defaultProps = {
        filters: [CommitteeOfficialFilter],
        uniqueFilterGroupId: "committeeMemberFilterGroup",
        displayLabel: "Members",
        helpText: "Filter committees by which legislators are members.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class CommitteeSubcommitteeFilterGroup extends Component {
    static defaultProps = {
        filters: [CommitteeSubcommitteeFilter],
        uniqueFilterGroupId: "subcommitteeFilterGroup",
        displayLabel: "Subcommittees",
        helpText: "Filter committees for the subcommittees of a particular committee.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class CommitteeListFilterGroup extends Component {
    static defaultProps = {
        filters: [
            createListFilter(DjangIO.app.models.QuorumDataType.committee.value),
            createNotInListFilter(DjangIO.app.models.QuorumDataType.committee.value),
            ManuallyChangedInListFilter,
        ],
        uniqueFilterGroupId: "committeeListFilterGroup",
        displayLabel: "Lists",
        helpText: "Filter committees by the lists you've saved to Projects.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class CommitteeProjectFilterGroup extends Component {
    static defaultProps = {
        filters: [inIssueFilter, notInIssueFilter],
        uniqueFilterGroupId: "committeeProjectFilterGroup",
        displayLabel: "Issues",
        helpText: "Filter for committees by tagged Issues.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class CommitteeRegionFilterGroup extends Component {
    static defaultProps = {
        filters: [CommitteeSupportedRegionsFilter, RegionCountryEUFilter],
        uniqueFilterGroupId: "committeeRegionFilterGroup",
        displayLabel: "Region",
        helpText: "Filter for committees from a single region or group of regions.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}
